// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/auth/AuthPages.css */

/* ============================================
   AUTH PAGES — Shared Styles
   ============================================ */

.auth-page {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-cream-bg);
  padding: var(--space-md);
}

.auth-card {
  width: 100%;
  max-width: 400px;
  background-color: var(--color-card-white);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  padding: var(--space-xl) var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
}

/* ---- Header ---- */
.auth-card__header {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.auth-card__logo {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-extrabold);
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
}

.auth-card__logo-icon {
  font-size: 1.75rem;
}

.auth-card__title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-secondary);
  margin-top: var(--space-xs);
}

.auth-card__subtitle {
  font-size: var(--font-size-sm);
  color: var(--color-text-light);
  line-height: var(--line-height-normal);
}

/* ---- Form ---- */
.auth-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

/* ---- Error Alert ---- */
.auth-error {
  background-color: rgba(229, 57, 53, 0.08);
  border: 1.5px solid var(--color-error);
  color: var(--color-error);
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  text-align: center;
}

/* ---- Form Fields ---- */
.auth-field {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.auth-field__label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
}

.auth-field__input {
  padding: var(--space-sm) var(--space-md);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  background-color: var(--color-card-white);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  appearance: none;
  font-family: inherit;
}

.auth-field__input:focus {
  outline: none;
  border-color: var(--color-wood-medium);
  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);
}

.auth-field__input::placeholder {
  color: var(--color-text-light);
}

.auth-field__hint {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
}

/* ---- Submit Button ---- */
.auth-submit-btn {
  width: 100%;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  border: none;
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  box-shadow: var(--shadow-md);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
}

.auth-submit-btn:hover:not(:disabled) {
  background-color: var(--color-wood-dark);
}

.auth-submit-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.auth-submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.auth-submit-btn__spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: auth-spin 0.6s linear infinite;
}

@keyframes auth-spin {
  to { transform: rotate(360deg); }
}

/* ---- Links ---- */
.auth-link-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.auth-link {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-wood-medium);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.auth-link:hover {
  color: var(--color-wood-dark);
  text-decoration: underline;
}

/* ---- Footer ---- */
.auth-footer {
  text-align: center;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.auth-footer a {
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-medium);
  text-decoration: none;
}

.auth-footer a:hover {
  text-decoration: underline;
}

/* ---- Success / Info Card ---- */
.auth-status-card {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-md);
}

.auth-status-card__icon {
  font-size: 3rem;
  line-height: 1;
}

.auth-status-card__title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.auth-status-card__message {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
  max-width: 320px;
}

.auth-status-card__message strong {
  color: var(--color-text-primary);
}

.auth-action-btn {
  display: inline-block;
  padding: var(--space-sm) var(--space-xl);
  border-radius: var(--radius-md);
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  text-decoration: none;
  transition: all var(--transition-fast);
  border: none;
  cursor: pointer;
  font-family: inherit;
}

.auth-action-btn:hover {
  background-color: var(--color-wood-dark);
}

.auth-action-btn--outline {
  background-color: transparent;
  color: var(--color-wood-medium);
  border: 1.5px solid var(--color-wood-medium);
}

.auth-action-btn--outline:hover {
  background-color: rgba(139, 94, 60, 0.06);
}

/* ---- Loading spinner for verify page ---- */
.auth-loading-spinner {
  font-size: 3rem;
  animation: auth-spin 1.5s linear infinite;
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/AuthPages.css"],"names":[],"mappings":"AAAA,sFAAsF;;AAEtF;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,yCAAyC;EACzC,sCAAsC;EACtC,yBAAyB;EACzB,wCAAwC;EACxC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,yCAAyC;EACzC,kFAAkF;EAElF,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,YAAY;EACZ,0CAA0C;EAC1C,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,+BAA+B;EAC/B,0CAA0C;EAC1C,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,qBAAqB;EACrB,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,yCAAyC;AAC3C","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/auth/AuthPages.css */\n\n/* ============================================\n   AUTH PAGES — Shared Styles\n   ============================================ */\n\n.auth-page {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--color-cream-bg);\n  padding: var(--space-md);\n}\n\n.auth-card {\n  width: 100%;\n  max-width: 400px;\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-lg);\n  padding: var(--space-xl) var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-lg);\n}\n\n/* ---- Header ---- */\n.auth-card__header {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.auth-card__logo {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-extrabold);\n  color: var(--color-text-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n}\n\n.auth-card__logo-icon {\n  font-size: 1.75rem;\n}\n\n.auth-card__title {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-secondary);\n  margin-top: var(--space-xs);\n}\n\n.auth-card__subtitle {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-light);\n  line-height: var(--line-height-normal);\n}\n\n/* ---- Form ---- */\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n}\n\n/* ---- Error Alert ---- */\n.auth-error {\n  background-color: rgba(229, 57, 53, 0.08);\n  border: 1.5px solid var(--color-error);\n  color: var(--color-error);\n  padding: var(--space-sm) var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  text-align: center;\n}\n\n/* ---- Form Fields ---- */\n.auth-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.auth-field__label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary);\n}\n\n.auth-field__input {\n  padding: var(--space-sm) var(--space-md);\n  border: 1.5px solid var(--color-border);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  background-color: var(--color-card-white);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n  -webkit-appearance: none;\n  appearance: none;\n  font-family: inherit;\n}\n\n.auth-field__input:focus {\n  outline: none;\n  border-color: var(--color-wood-medium);\n  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);\n}\n\n.auth-field__input::placeholder {\n  color: var(--color-text-light);\n}\n\n.auth-field__hint {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n}\n\n/* ---- Submit Button ---- */\n.auth-submit-btn {\n  width: 100%;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  border: none;\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  box-shadow: var(--shadow-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n}\n\n.auth-submit-btn:hover:not(:disabled) {\n  background-color: var(--color-wood-dark);\n}\n\n.auth-submit-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.auth-submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.auth-submit-btn__spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: auth-spin 0.6s linear infinite;\n}\n\n@keyframes auth-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ---- Links ---- */\n.auth-link-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.auth-link {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-wood-medium);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.auth-link:hover {\n  color: var(--color-wood-dark);\n  text-decoration: underline;\n}\n\n/* ---- Footer ---- */\n.auth-footer {\n  text-align: center;\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n\n.auth-footer a {\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-medium);\n  text-decoration: none;\n}\n\n.auth-footer a:hover {\n  text-decoration: underline;\n}\n\n/* ---- Success / Info Card ---- */\n.auth-status-card {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-md);\n}\n\n.auth-status-card__icon {\n  font-size: 3rem;\n  line-height: 1;\n}\n\n.auth-status-card__title {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.auth-status-card__message {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  line-height: var(--line-height-normal);\n  max-width: 320px;\n}\n\n.auth-status-card__message strong {\n  color: var(--color-text-primary);\n}\n\n.auth-action-btn {\n  display: inline-block;\n  padding: var(--space-sm) var(--space-xl);\n  border-radius: var(--radius-md);\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  text-decoration: none;\n  transition: all var(--transition-fast);\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.auth-action-btn:hover {\n  background-color: var(--color-wood-dark);\n}\n\n.auth-action-btn--outline {\n  background-color: transparent;\n  color: var(--color-wood-medium);\n  border: 1.5px solid var(--color-wood-medium);\n}\n\n.auth-action-btn--outline:hover {\n  background-color: rgba(139, 94, 60, 0.06);\n}\n\n/* ---- Loading spinner for verify page ---- */\n.auth-loading-spinner {\n  font-size: 3rem;\n  animation: auth-spin 1.5s linear infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
